import * as _ from 'lodash';

import { ADD_EXPENSES, ExpenseListAction, SET_CURRENCY_VIEW, UPDATE_EXPENSE } from '@Actions/expenseListActions';

import { ICurrencyView } from '@ClientModels/CurrencyView';
import { IExpenseModel } from '@Shared/models';

interface IExpenseListState {
  expenses: IExpenseModel[];
  currencyView: ICurrencyView;
}

export const defaultState: IExpenseListState = {
  expenses: [],
  currencyView: 'Home Currency'
};

export const expenseListReducer = function (state = defaultState, action: ExpenseListAction): IExpenseListState {
  function uniq(expenses: IExpenseModel[]) {
    return _.uniqBy(expenses, (expense) => expense.id);
  }

  switch (action.type) {
    case ADD_EXPENSES:
      return _.assign({}, state, {
        expenses: uniq([...action.expenses, ...state.expenses])
      });
    case UPDATE_EXPENSE: {
      const updatedExpenses = state.expenses.map((expense) => {
        if (expense.id === action.expense.id) {
          return { ...expense, ...action.expense };
        }
        return expense;
      });

      return { ...state, expenses: updatedExpenses };
    }
    case SET_CURRENCY_VIEW: {
      return { ...state, currencyView: action.currencyView };
    }
    default:
      return state;
  }
};
